import { useContext,useEffect } from "react";
import {useSelector, useDispatch } from "react-redux";
import { api } from "../../../redux/api";
import Split from "react-split";
import TemplatePropertiesContainer from "/src/components/TemplateProperties/TemplatePropertiesContainer";
import ItemPropertiesContainer from "/src/components/ItemProperties/ItemPropertiesContainer";
import InboundTemplatePanel from "/src/components/Panel/InboundTemplatePanel";
import WorkflowGroupPanel from "/src/components/Panel/WorkflowGroupPanel";
import DocPanel from "/src/components/Panel/DocPanel";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { treeActions } from "../../../redux/slices/treeSlice";
import { cloneDeep } from "lodash";
function Inbound(props) {
  const parentScreen =  useContext(ParentScreenCtx);
  const { account } = useSelector((state) => state.queryParams);
  const { showDocFile } = useSelector(state => state.treeData.inbound)
  const dispatch = useDispatch();
  const currentTab  = useSelector(state => state.treeData.inbound.rightTree.currentTab)
  const selectedNode = useSelector(state => state.treeData[parentScreen].leftTree.tree.body.selectedNode);
  const rightSelectedNode = useSelector(state => state.treeData[parentScreen].rightTree.tree[currentTab].selectedNode);
  // On inbound screen mount (or account/dispatch props are updated) make a request to get the inbound template list
  useEffect(() => {
    // Add a subscription to endpoint
    const copySelecteNode = cloneDeep(rightSelectedNode);
    const tab = currentTab;
    dispatch(
      api.endpoints.getInboundTemplateList.initiate(
        {
          account,
        },
        { subscribe: false }
      )
    );
    dispatch(
      treeActions.setLeftTreeContextActionValue({
        screen: parentScreen,
        data: {
          name: selectedNode.title,
          workflowGroup: selectedNode.workflowGroup,
          tabChanged: true
        },
      })
    );
    dispatch(
      treeActions.setRightTreeSelectedNode({
        screen: parentScreen,
        type: tab,
        data: copySelecteNode,
      })
    );
    dispatch(
      api.endpoints.getPdcList.initiate({
        account,
        direction: "in",
        datatype: "database",
      })
    );
  }, [dispatch, account, props.val]); //eslint-disable-line react-hooks/exhaustive-deps
  

  return (
    <div className="wbb-tab-container">
      {/* three horiz. panels split */}
      <Split
        className="split height-100 width-100 flex"
        direction="horizontal"
        gutterSize={4}
        snapOffset={0}
        dragInterval={4}
        sizes={[34, 66]} // can define the sizes on initial render if needed.
      >
        {/* left panel- wfg tree and template properties vert. split*/}
        <div className="height-100" style={{ minWidth: "380px"}}>
          <Split
            style={{ height: "100%" }}
            className="split"
            direction="vertical"
            gutterSize={4}
            snapOffset={0}
            dragInterval={4}
          >
            <WorkflowGroupPanel />
            <TemplatePropertiesContainer />
          </Split>
        </div>
        <div>
          {showDocFile && <DocPanel />}
          
          <Split
            className={(!showDocFile ? " split height-100 width-100 flex" : "display-none")}
            direction="horizontal"
            gutterSize={4}
            snapOffset={0}
            dragInterval={4}
          >
            <ItemPropertiesContainer />
            <InboundTemplatePanel/>
          </Split>
          
        </div>
      </Split>
    </div>
  );
}

export default Inbound;
